import { Channel, Conversation } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Conversations/Conversations.Controller.ts
export class ConversationsAPI {
  static async getConversations(orgId: number) {
    return APIService.Server.get<Conversation[]>(`/conversations/org/${orgId}`);
  }
  static async takeoverConversation(orgId: number, userId: number, memberId: number, channel?: Channel) {
    return APIService.Server.put<Conversation>(`/conversations/org/${orgId}/member/${memberId}/user/${userId}/takeover`, { channel });
  }
  static async endTakenOverConversation(orgId: number, userId: number, memberId: number) {
    return APIService.Server.put<Conversation>(`/conversations/org/${orgId}/member/${memberId}/user/${userId}/end-takeover`);
  }
  static async setArchivedForConversation(orgId: number, userId: number, archived: boolean) {
    return APIService.Server.put<Conversation>(`/conversations/org/${orgId}/user/${userId}/set-archive/${archived}`);
  }
  // static async createConversation(orgId: number, conversation: Conversation) {
  //     return APIService.Conversations.post<Conversation>(`/org/${orgId}/conversations`, conversation);
  // }
  // static async updateConversation(orgId: number, conversation: Conversation) {
  //     return APIService.Conversations.put<Conversation>(`/org/${orgId}/conversations/${conversation.id}`, conversation);
  // }
  // static async deleteConversation(orgId: number, conversationId: number) {
  //     return APIService.Conversations.delete<boolean>(`/org/${orgId}/conversations/${conversationId}`);
  // }
}
